import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Button } from "react-bootstrap";
import { toast } from "react-toastify";
import ImageUploading from "react-images-uploading";
import { uploadImage } from "../../../../redux/reducers/postApiSlice";
import SelectDropdown from "../../../components-react/SelectDropdown";
import Loader from "../../../ui/Loader";
import { validateHygineForm1 } from "../HygineValidations";
import { fetchHygieneCategoryData } from "../../../../redux/hygiene-reducers/hygieneSlice";
import {
  fetchTicketSystemIssueTypeData,
  fetchTicketSystemCategoryData,
  fetchTicketSystemSubCategoryData,
} from "../../../../redux/reducers/ticketSystemSlice";
import { showConfirmAlert } from "../../../components-react/ReactAlert";
import { commonPostPutApi } from "../../../../redux/reducers/commonApiSlice";
import { add_hygiene_logs } from "../../../../data/ApiEndpoints";

const TaskUpdateForm = ({ userInfoData, rowData, callFunction }) => {
  const dispatch = useDispatch();
  const { hygieneCategories } = useSelector((state) => state.hygiene);
  const {
    ticketSystemIssueTypeData,
    ticketSystemCategoryData,
    ticketSystemSubCategoryData,
  } = useSelector((state) => state.ticketSystem);
  const { postPutLoading } = useSelector((state) => state.common);
  const { loading: imageUploadLoading } = useSelector((state) => state.postApi);

  const [hygieneStatuses, setHygieneStatuses] = useState([]);
  const [issueTypes, setIssueTypes] = useState([]);
  const [categories, setCategories] = useState([]);
  const [subCategories, setSubCategories] = useState([]);

  const iniFormValues = {
    mobileNumber: userInfoData?.mobile || "",
    taskUid: rowData.uid || "",
    taskId: rowData.task_id || "",
    taskName: rowData.task_name || "",
    selectedTaskStatus: "",
    taskDescription: "",
    taskStatus: "",
    task: rowData,
    selectedIssueType: "",
    selectedCategory: "",
    selectedSubCategory: "",
    taskImages: rowData.img_quantity
      ? [...Array(Number(rowData.img_quantity) || 0)].map(() => [])
      : [],
    taskVideos: rowData.vid_quantity
      ? [...Array(Number(rowData.vid_quantity) || 0)].map(() => [])
      : [],
  };
  const [formValues, setFormValues] = useState(iniFormValues);
  const [formErrors, setFormErrors] = useState({});

  const taskImagesLength = formValues.taskImages?.length || 0;
  const taskVideosLength = formValues.taskVideos?.length || 0;

  const onChangeInput = (e) => {
    const { name, value } = e.target;

    setFormValues((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const onChangeDropdown = (name, value) => {
    setFormValues((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleImageUpload = async (imgIndex, updatedImageList, name) => {
    if (!["taskImages", "taskVideos"].includes(name)) {
      console.error("Invalid media type:", name);
      return;
    }

    if (!updatedImageList || updatedImageList.length === 0) return;

    const newFile = updatedImageList[0]?.file;
    if (!newFile) return;

    try {
      const result = await handleUploadImage(newFile, name);
      const uploadedUrl = result?.payload?.image_url || "";

      setFormValues((prev) => {
        const updatedMedia = [...prev[name]];

        updatedMedia[imgIndex] = updatedMedia[imgIndex] || [];

        updatedMedia[imgIndex] = [
          {
            data_url: updatedImageList[0].data_url,
            image_url: uploadedUrl,
          },
        ];

        return { ...prev, [name]: updatedMedia };
      });
    } catch (error) {
      console.error("Image upload failed:", error);
    }
  };

  const handleOnClickImage = (imgIndex, name) => {
    if (!["taskImages", "taskVideos"].includes(name)) {
      console.error("Invalid media type:", name);
      return;
    }

    const input = document.createElement("input");
    input.type = "file";
    input.accept = name === "taskImages" ? "image/*" : "video/*";
    input.capture = "environment";

    input.onchange = async (e) => {
      const file = e.target.files[0];
      if (!file) return;

      const reader = new FileReader();
      reader.onload = async () => {
        const dataURL = reader.result;

        try {
          const result = await handleUploadImage(file, name);
          const uploadedUrl = result?.payload?.image_url || "";

          setFormValues((prev) => {
            const updatedMedia = [...prev[name]];

            updatedMedia[imgIndex] = updatedMedia[imgIndex] || [];

            updatedMedia[imgIndex] = [
              {
                data_url: dataURL,
                image_url: uploadedUrl,
              },
            ];

            return { ...prev, [name]: updatedMedia };
          });
        } catch (error) {
          console.error("Image upload failed:", error);
        }
      };
      reader.readAsDataURL(file);
    };

    input.click();
  };

  const handleUploadImage = async (file, fileName) => {
    try {
      const actionResult = dispatch(
        uploadImage({ file, TOKEN: userInfoData?.token })
      );
      const result = await actionResult;

      if (result?.payload?.status) {
        return result;
      } else {
        console.error(
          "Upload error:",
          result?.error?.message || result?.payload?.message
        );
      }
    } catch (error) {
      console.error("handleUploadImage ERROR:", error);
    }
  };

  function getHygieneTasks(filters) {
    dispatch(
      fetchHygieneCategoryData({
        filters: filters,
        token: userInfoData?.token,
      })
    );
  }

  const handleAdd = async (requestUid) => {
    const addGymReq = formValues.selectedTaskStatus?.info?.add_gym_req || false;
    const addonTicket = requestUid ? 1 : addGymReq ? 1 : 0;

    const payload = {
      sub_task_id: formValues.task?.uid || "",
      task_status_id: formValues.selectedTaskStatus?.value || "",
      status: "completed",
      images_arr:
        formValues.taskImages?.flat()?.map((img) => img?.image_url) || [],
      video_arr:
        formValues.taskVideos?.flat()?.map((vid) => vid?.image_url) || [],
      description: formValues?.taskDescription || "",
      addon_ticket: addonTicket,
      gym_req_id: requestUid || "",
    };

    if (addonTicket === 1 && addGymReq) {
      payload.ticket = {
        doc_id: rowData?.uid || "",
        gym_id: userInfoData?.gym_id || "",
        issue_type_id: formValues.selectedIssueType?.value || "",
        category_id: formValues.selectedCategory?.value || "",
        sub_category_id: formValues.selectedSubCategory?.value || "",
        priority: rowData?.priority || "medium",
        description: formValues?.taskDescription || "",
        is_recurring: 0,
        created_by: userInfoData?.user_id || userInfoData?.uid || "",
        status: "opened",
        imgArr:
          formValues.taskImages?.flat()?.map((img) => img?.image_url) || [],
        videoArr:
          formValues.taskVideos?.flat()?.map((vid) => vid?.image_url) || [],
      };
    }

    const method = "POST";
    const endpoint = add_hygiene_logs;
    const token = userInfoData?.token;

    try {
      const result = await dispatch(
        commonPostPutApi({ method, endpoint, payload, token })
      );

      if (result?.payload?.status) {
        toast.success(result?.payload?.message || "Success!");
        callFunction();
      } else {
        const errorMessage = result?.payload?.message || result?.error?.message;
        toast.error(errorMessage || "Something Went Wrong!");
      }
    } catch (error) {
      console.error("Error making POST request:", error);
    }
  };

  const onSubmitForm = async () => {
    const errors = validateHygineForm1(formValues);
    setFormErrors(errors);

    if (Object.keys(errors).length === 0) {
      const handleConfirm = async () => {
        await handleAdd();
      };

      const addGymReq = formValues.selectedTaskStatus?.info?.add_gym_req;
      const statusName = formValues.selectedTaskStatus?.info?.name || "N/A";
      const confirmMessage = addGymReq
        ? `You are about to submit this task and create a gym ticket with the following details:\n\n• Task: ${
            formValues.taskName || "N/A"
          }\n• Status: ${statusName}\n• Issue Type: ${
            formValues.selectedIssueType?.label || "N/A"
          }\n• Category: ${
            formValues.selectedCategory?.label || "N/A"
          }\n• Sub-Category: ${
            formValues.selectedSubCategory?.label || "N/A"
          }\n\nDo you want to proceed?`
        : `You are about to submit this task:\n\n• Task: ${
            formValues.taskName || "N/A"
          }\n• Status: ${statusName}\n\nDo you want to proceed?`;

      showConfirmAlert(handleConfirm, confirmMessage, "Cancel", "Submit");
    }
  };

  useEffect(() => {
    const filter = {
      status: "active",
      page: 1,
      limit: 1000,
    };

    getHygieneTasks(filter);
  }, []);

  useEffect(() => {
    if (hygieneCategories?.data?.length > 0) {
      const allCats = hygieneCategories.data?.map((item) => ({
        value: item.uid,
        label: (
          <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
            <span
              style={{
                display: "inline-block",
                width: "16px",
                height: "16px",
                backgroundColor: item.color_hex,
                borderRadius: "50%",
                border: "1px solid #ddd",
              }}
            ></span>
            {item.name}
          </div>
        ),
        info: item,
      }));
      setHygieneStatuses(allCats);
    } else {
      setHygieneStatuses([]);
    }
  }, [hygieneCategories]);

  useEffect(() => {
    const addGymReq = formValues.selectedTaskStatus?.info?.add_gym_req;
    if (addGymReq) {
      dispatch(
        fetchTicketSystemIssueTypeData({
          filters: { status: "active", limit: 100, page: 1 },
          token: userInfoData?.token,
        })
      );
    } else {
      setFormValues((prev) => ({
        ...prev,
        selectedIssueType: "",
        selectedCategory: "",
        selectedSubCategory: "",
      }));
      setIssueTypes([]);
      setCategories([]);
      setSubCategories([]);
    }
  }, [formValues.selectedTaskStatus?.info?.add_gym_req]);

  useEffect(() => {
    if (ticketSystemIssueTypeData?.data?.length > 0) {
      const issueTypeOptions = ticketSystemIssueTypeData.data.map((item) => ({
        value: item.uid,
        label: item.name,
        info: item,
      }));
      setIssueTypes(issueTypeOptions);
    } else {
      setIssueTypes([]);
    }
  }, [ticketSystemIssueTypeData]);

  useEffect(() => {
    if (formValues.selectedIssueType?.value) {
      dispatch(
        fetchTicketSystemCategoryData({
          issue_type_id: formValues.selectedIssueType.value,
          token: userInfoData?.token,
          filters: {},
        })
      );
      setFormValues((prev) => ({
        ...prev,
        selectedCategory: "",
        selectedSubCategory: "",
      }));
      setSubCategories([]);
    } else {
      setCategories([]);
      setFormValues((prev) => ({
        ...prev,
        selectedCategory: "",
        selectedSubCategory: "",
      }));
      setSubCategories([]);
    }
  }, [formValues.selectedIssueType?.value]);

  useEffect(() => {
    if (ticketSystemCategoryData?.length > 0) {
      const categoryOptions = ticketSystemCategoryData.map((item) => ({
        value: item.uid,
        label: item.name,
        info: item,
      }));
      setCategories(categoryOptions);
    } else {
      setCategories([]);
    }
  }, [ticketSystemCategoryData]);

  useEffect(() => {
    if (formValues.selectedCategory?.value) {
      dispatch(
        fetchTicketSystemSubCategoryData({
          category_id: formValues.selectedCategory.value,
          token: userInfoData?.token,
          filters: {},
        })
      );
      setFormValues((prev) => ({
        ...prev,
        selectedSubCategory: "",
      }));
    } else {
      setSubCategories([]);
      setFormValues((prev) => ({
        ...prev,
        selectedSubCategory: "",
      }));
    }
  }, [formValues.selectedCategory?.value]);

  useEffect(() => {
    if (ticketSystemSubCategoryData?.length > 0) {
      const subCategoryOptions = ticketSystemSubCategoryData.map((item) => ({
        value: item.uid,
        label: item.name,
        info: item,
      }));
      setSubCategories(subCategoryOptions);
    } else {
      setSubCategories([]);
    }
  }, [ticketSystemSubCategoryData]);

  console.log("formValues=> ", formValues);
  console.log("formErrors=> ", formErrors);

  return (
    <>
      {/* <Modal
        isOpen={requestData.isModOpen}
        onRequestClose={onCloseRequestModal}
        contentLabel="Detail Modal"
        ariaHideApp={false}
      >
        <div className={`createNewCTOModalContainer`}>
          {requestData.modName !== "hygiene-tasks" && (
            <ModalHeadAndClose
              title={`Open Requests`}
              onClose={onCloseRequestModal}
            />
          )}

          {requestData.modName === "hygiene-tasks" ? (
            <TaskNStatus
              userInfoData={userInfoData}
              onCloseModal={onCloseRequestModal}
            />
          ) : (
            <PreviousRequests
              userInfoData={userInfoData}
              taskID={requestData.requestedDataTaskUID}
              onCloseModal={onCloseRequestModal}
              handleAdd={handleAdd}
            />
          )}
        </div>
      </Modal> */}

      <div className="form-container open-form-page-container mod-with-images mt30" style={{marginTop: "30px"}}>
        <form className="formContainer" style={{ gap: "1rem" }}>
          <div className={`formInputsGrid twoGridSystem`}>
            <div className="formInputBox">
              <label htmlFor="selectedTaskStatus" className="formInputLabel">
                Task status <span className="required">*</span>
              </label>

              <div
                className={`commonWrapper ${
                  formErrors.selectedTaskStatus ? "formError" : ""
                }`}
              >
                <SelectDropdown
                  options={hygieneStatuses}
                  selectedOption={formValues.selectedTaskStatus}
                  setSelectedOption={(selectedValue) =>
                    onChangeDropdown("selectedTaskStatus", selectedValue)
                  }
                  name="task status"
                  preventKeyboardOpen={true}
                />
              </div>
            </div>

            {formValues.selectedTaskStatus?.info?.add_gym_req ? (
              <>
                <div className="formInputBox">
                  <label htmlFor="selectedIssueType" className="formInputLabel">
                    Ticket - Issue Type <span className="required">*</span>
                  </label>

                  <div
                    className={`commonWrapper ${
                      formErrors.selectedIssueType ? "formError" : ""
                    }`}
                  >
                    <SelectDropdown
                      options={issueTypes}
                      selectedOption={formValues.selectedIssueType}
                      setSelectedOption={(selectedValue) =>
                        onChangeDropdown("selectedIssueType", selectedValue)
                      }
                      name="issue type"
                      preventKeyboardOpen={true}
                    />
                  </div>
                </div>

                {formValues.selectedIssueType && (
                  <div className="formInputBox">
                    <label
                      htmlFor="selectedCategory"
                      className="formInputLabel"
                    >
                      Ticket - Issue Category{" "}
                      <span className="required">*</span>
                    </label>

                    <div
                      className={`commonWrapper ${
                        formErrors.selectedCategory ? "formError" : ""
                      }`}
                    >
                      <SelectDropdown
                        options={categories}
                        selectedOption={formValues.selectedCategory}
                        setSelectedOption={(selectedValue) =>
                          onChangeDropdown("selectedCategory", selectedValue)
                        }
                        name="category"
                        preventKeyboardOpen={true}
                      />
                    </div>
                  </div>
                )}

                {formValues.selectedCategory && (
                  <div className="formInputBox">
                    <label
                      htmlFor="selectedSubCategory"
                      className="formInputLabel"
                    >
                      Ticket - Issue Sub Category{" "}
                      <span className="required">*</span>
                    </label>

                    <div
                      className={`commonWrapper ${
                        formErrors.selectedSubCategory ? "formError" : ""
                      }`}
                    >
                      <SelectDropdown
                        options={subCategories}
                        selectedOption={formValues.selectedSubCategory}
                        setSelectedOption={(selectedValue) =>
                          onChangeDropdown("selectedSubCategory", selectedValue)
                        }
                        name="sub category"
                        preventKeyboardOpen={true}
                      />
                    </div>
                  </div>
                )}

                <div className="formInputBox span2">
                  <label htmlFor="taskDescription" className="formInputLabel">
                    Task description <span className="required">*</span>
                  </label>

                  <textarea
                    name="taskDescription"
                    className={`formInput ${
                      formErrors.taskDescription && "formError"
                    }`}
                    style={{ minHeight: "150px" }}
                    placeholder="Enter Details"
                    value={formValues.taskDescription}
                    onChange={(e) => onChangeInput(e)}
                  ></textarea>
                </div>
              </>
            ) : null}
          </div>

          {taskImagesLength > 0 || taskVideosLength > 0 ? (
            <div className={`formInputsGrid twoGridSystem`}>
              {taskImagesLength !== 0 && (
                <div className="formInputBox">
                  <label className="formInputLabel">
                    Upload Image <span className="required">*</span>
                  </label>
                  <div
                    className={`upload-container grid-2 ${
                      formErrors.taskImages ? "formError" : ""
                    }`}
                  >
                    {formValues.taskImages.map((imageList, imgIndex) => {
                      return (
                        <div key={imgIndex} className="upload-box">
                          <ImageUploading
                            multiple
                            value={imageList}
                            maxNumber={1}
                            dataURLKey="data_url"
                            acceptType={["image/*"]}
                            onChange={(updatedImageList) =>
                              handleImageUpload(
                                imgIndex,
                                updatedImageList,
                                "taskImages"
                              )
                            }
                          >
                            {({
                              imageList = [],
                              onImageUpload,
                              isDragging,
                              dragProps,
                            }) => (
                              <div className="upload__image-wrapper">
                                {imageUploadLoading ? (
                                  <Loader />
                                ) : (
                                  <>
                                    {imageList.length === 0 && (
                                      <button
                                        type="button"
                                        style={
                                          isDragging
                                            ? { color: "red" }
                                            : undefined
                                        }
                                        onClick={() =>
                                          handleOnClickImage(
                                            imgIndex,
                                            "taskImages"
                                          )
                                        }
                                        {...dragProps}
                                      >
                                        📷 Upload Image
                                      </button>
                                    )}
                                    {imageList.length > 0 &&
                                      imageList.map((image, idx) => (
                                        <div
                                          key={idx}
                                          className="image-item"
                                          onClick={() =>
                                            handleOnClickImage(
                                              imgIndex,
                                              "taskImages"
                                            )
                                          }
                                        >
                                          <img
                                            src={image.data_url}
                                            alt=""
                                            width="100"
                                          />
                                        </div>
                                      ))}
                                  </>
                                )}
                              </div>
                            )}
                          </ImageUploading>
                        </div>
                      );
                    })}
                  </div>
                </div>
              )}

              {taskVideosLength !== 0 && (
                <div className="formInputBox">
                  <label className="formInputLabel">
                    Upload videos <span className="required">*</span>
                  </label>
                  <div
                    className={`upload-container grid-2 ${
                      formErrors.taskVideos ? "formError" : ""
                    }`}
                  >
                    {formValues.taskVideos.map((_, videoIndex) => (
                      <div key={videoIndex} className="upload-box">
                        <ImageUploading
                          multiple
                          value={formValues.taskVideos[videoIndex] || []}
                          maxNumber={1}
                          dataURLKey="data_url"
                          acceptType={["video/*"]}
                          onChange={(updatedVideoList) =>
                            handleImageUpload(
                              videoIndex,
                              updatedVideoList,
                              "taskVideos"
                            )
                          }
                        >
                          {({
                            imageList,
                            onImageUpload,
                            isDragging,
                            dragProps,
                          }) => (
                            <div className="upload__image-wrapper">
                              {imageUploadLoading ? (
                                <Loader />
                              ) : (
                                <>
                                  {imageList.length === 0 && (
                                    <button
                                      type="button"
                                      style={
                                        isDragging
                                          ? { color: "red" }
                                          : undefined
                                      }
                                      onClick={() =>
                                        handleOnClickImage(
                                          videoIndex,
                                          "taskVideos"
                                        )
                                      }
                                      {...dragProps}
                                    >
                                      📷 Upload Video
                                    </button>
                                  )}
                                  {imageList.length > 0 &&
                                    imageList.map((video, idx) => (
                                      <div
                                        key={idx}
                                        className="image-item"
                                        onClick={() =>
                                          handleOnClickImage(
                                            videoIndex,
                                            "taskVideos"
                                          )
                                        }
                                      >
                                        <video width="100" controls>
                                          <source
                                            src={video.data_url}
                                            type="video/mp4"
                                          />
                                        </video>
                                      </div>
                                    ))}
                                </>
                              )}
                            </div>
                          )}
                        </ImageUploading>
                      </div>
                    ))}
                  </div>
                </div>
              )}
            </div>
          ) : null}

          <div className="formButtons mt15">
            <Button
              type="button"
              className="saveBtn"
              variant="danger"
              disabled={postPutLoading}
              onClick={onSubmitForm}
            >
              {postPutLoading ? <Loader /> : "Submit"}
            </Button>
          </div>
        </form>
      </div>
    </>
  );
};

export default TaskUpdateForm;
